import type { MeetingTypeDescription } from '../services/schema/MeetingTypeDescription';
import { BookingPrivacyType } from '../services/schema/MeetingTypeDescription';
import { getLargeThemeImageUrl } from './getThemeImages';

export function parseMeetingTypeDescription(serviceDescription: string): MeetingTypeDescription {
    let parsedDescription: any = undefined;
    if (serviceDescription?.indexOf('description') > -1) {
        try {
            parsedDescription = JSON.parse(serviceDescription);
            parsedDescription.themeId = getLargeThemeImageUrl(
                Number(parsedDescription.themeId) ?? 0
            );
            parsedDescription.privacyType =
                parsedDescription.privacyType ?? BookingPrivacyType.PublicMeetingType;
            return parsedDescription;
        } catch (error) {
            // TODO: log error
            return getDefaultParsedDescription(serviceDescription);
        }
    }
    return getDefaultParsedDescription(serviceDescription);
}

function getDefaultParsedDescription(serviceDescription: string): MeetingTypeDescription {
    return {
        description: serviceDescription,
        themeId: getLargeThemeImageUrl(0),
        privacyType: BookingPrivacyType.PublicMeetingType,
    };
}
